import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function ChatsTab() {
  const [sessions, setSessions] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);

  useEffect(() => {
    api.get("/admin/marketing/chats").then((r) => setSessions(r.data));
  }, []);

  const openSession = async (s) => {
    setActive(s.session_id);
    const { data } = await api.get(`/admin/marketing/chats/${s.session_id}`);
    setMsgs(data);
  };

  return (
    <div data-testid="chats-tab" className="grid grid-cols-1 lg:grid-cols-12 gap-6">
      <div className="lg:col-span-4 border border-slate-200 rounded-sm divide-y divide-slate-200 max-h-[640px] overflow-y-auto">
        {sessions.length === 0 && <div className="p-6 text-slate-500 text-sm" data-testid="chats-empty">No conversations yet. Max is waiting on the landing page.</div>}
        {sessions.map((s) => (
          <button key={s.session_id} onClick={() => openSession(s)} data-testid={`chat-session-${s.session_id}`} className={`w-full text-left p-4 hover:bg-slate-50 ${active === s.session_id ? "bg-orange-50" : ""}`}>
            <div className="font-mono text-xs text-slate-500">{s.session_id}</div>
            <div className="text-sm text-slate-900 mt-1">{s.messages} messages · {s.started_at?.slice(0, 16).replace("T", " ")}</div>
          </button>
        ))}
      </div>
      <div className="lg:col-span-8 border border-slate-200 rounded-sm p-5 bg-slate-50 min-h-[300px] space-y-3" data-testid="chat-transcript">
        {!active && <div className="text-slate-500 text-sm">Select a conversation to read the transcript.</div>}
        {msgs.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-start" : "justify-end"}`}>
            <div className={`max-w-[80%] px-3 py-2 text-sm whitespace-pre-wrap rounded-sm ${m.role === "user" ? "bg-white border border-slate-200" : "bg-slate-950 text-white"}`}>
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-60 mb-1">{m.role === "user" ? "Visitor" : "Max"}</div>
              {m.content}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
